export default {
  name    : 'TagCommon',
  computed: {},
  methods : {
    getTagById(id) {
      return this.$dataStore?.App?.Tags?.find(tag => parseInt(tag.Id) === parseInt(id))
    }
  }
}
